/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {triggerBalanceCheck} from '../api'

export const useMutationTriggerBalanceCheck = createReactQueryMutationHook('triggerBalanceCheck', triggerBalanceCheck)
